import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Page} from "../components/add-edit-page/model/page";

@Injectable()
export class PagesService {
  previewPageContentKey: string = 'previewPageContent';
  constructor(private _http: HttpClient) {
  }

  /* PAGES */
  checkUserHasRights(pageId: number) {
    return this._http.post<any>('api/m/pages/hasRights', pageId);
  }

  getPageContent(pageId: number) {
    return this._http.post<Page>('api/s/pages/get', pageId);
  }

  addNewPage(params: any) {
    console.log('PagesService addNewPage' , params);
    return this._http.post<any>('api/m/pages/add', params);
  }

  editPage(params: any) {
    return this._http.post<any>('api/m/pages/edit', params);
  }

  publishPage(pageId: any) {
    return this._http.post<any>('api/m/pages/publish', pageId);
  }

  disblePage(pageId: any) {
    return this._http.post<any>('api/m/pages/disable', pageId);
  }

  deletePage(pageId: any) {
    return this._http.post<any>('api/m/pages/delete', pageId);
  }

  setPreviewPageContent(page: Page) {
    sessionStorage.setItem(this.previewPageContentKey, JSON.stringify(page));
  }
  getPreviewPageContent(): any {
    let page: Page = JSON.parse(sessionStorage.getItem(this.previewPageContentKey));
    return page;
  }
  removePreviewPageContent() {
    sessionStorage.removeItem(this.previewPageContentKey);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/moderator/services/pages.service.ts